export const SIMPLIFIED_MAP_RENDERING_STORAGE_KEY = "simplified-map-rendering";

export const readSimplifiedMapRendering = (
    storage: Pick<Storage, "getItem"> | undefined = typeof localStorage !== "undefined" ? localStorage : undefined
): boolean => {
    try {
        return storage?.getItem(SIMPLIFIED_MAP_RENDERING_STORAGE_KEY) === "true";
    } catch {
        return false;
    }
};

export const writeSimplifiedMapRendering = (
    value: boolean,
    storage: Pick<Storage, "setItem"> | undefined = typeof localStorage !== "undefined" ? localStorage : undefined
): void => {
    try {
        storage?.setItem(SIMPLIFIED_MAP_RENDERING_STORAGE_KEY, String(value));
    } catch {
        // LocalStorage can be unavailable in restricted WebView modes.
    }
};
